export default class MqttAdapter {
  constructor(backend) {
    this.client = backend;
  }

  subscribe(topic, onBroadcast) {
    if (onBroadcast == null) {
      return Promise.resolve();
    }

    // The ack callback reports failure by argument, so passing `resolve` directly
    // fulfilled the promise *with* an Error and every caller read a subscription that
    // was never granted as success.
    return new Promise((resolve, reject) => {
      this.client.subscribe(topic, onBroadcast, err => (err ? reject(err) : resolve()));
    });
  }

  unsubscribe(topic, onBroadcast) {
    if (onBroadcast == null) {
      return Promise.resolve();
    }

    this.client.unsubscribe(topic, onBroadcast);
    return Promise.resolve();
  }
}
